import { update } from '@kundinos/nanostores';
import { useStore } from '@kundinos/nanostores/react';

import { viewerModelStore } from './stores';

export const initViewerModelStore = (id: string) => {
  const initialData = {
    isOpenAr: false,
    isOpen360: false,
    id,
  };

  update(viewerModelStore, (prevValue) => {
    const exists = prevValue.find((val) => val.id === id);
    if (exists) return prevValue;

    return [...prevValue, initialData];
  });
};
export const useViewerModel = (id: string) => {
  const viewerModel = useStore(viewerModelStore);

  return viewerModel.find((item) => item.id === id);
};

export function changeAr(id: string, val: boolean) {
  update(viewerModelStore, (data) => {
    return data.map((elem) => {
      if (elem.id === id) {
        return { ...elem, isOpenAr: val };
      }
      return elem;
    });
  });
}

export function change360(id: string, val: boolean) {
  update(viewerModelStore, (data) => {
    return data.map((elem) => {
      if (elem.id === id) {
        return { ...elem, isOpen360: val };
      }
      return elem;
    });
  });
}

export function clear(id: string) {
  update(viewerModelStore, (data) => {
    return data.filter((elem) => elem.id !== id);
  });
}

export default null;
